import type { ImageProps } from "./image.types";

const deviceSizes = [320, 480, 768, 1024, 1280, 1440, 1920, 2560];

export const Image: React.FC<ImageProps> = (props) => {
  const { className, src, alt = "", ...rest } = props;

  const initialSrc = `${src}?w=${deviceSizes[0]}`;

  const srcSet = deviceSizes.map((size) => `${src}?w=${size} ${size}w`).join(", ");

  return <img className={className} src={initialSrc} srcSet={srcSet} alt={alt} {...rest} />;
};
